// extracted by mini-css-extract-plugin
export default {"title":"index_title_cYEx2","more":"index_more_tzcWI"};